import React, { useEffect, useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import tenantService from "../../service/tenant";
import { validateEmail } from "../../utilities/utillFunction";
import { accessTitle } from "../../lib/constants";
import { Dropdown } from "primereact/dropdown";
import { parseResponse, convertCamelCase } from "../../utilities/utillFunction";
import ConfigService from "../../service/configService";
import { Messages } from "primereact/messages";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";
import { Checkbox } from "primereact/checkbox";
import "react-phone-number-input/style.css";
import { MultiSelect } from "primereact/multiselect";
import { useHistory } from 'react-router-dom';
import { superAdmin, designerAdmin } from "../../lib/constants";
 
var citytimerId, timerId;

const InviteUser = (props) => {
    var userData = props.selectedUser;
    const serviceId = localStorage.getItem("serviceId");
    const serviceData = JSON.parse(localStorage.getItem("service"));
    const [name, setName] = useState(userData ? userData.user.name : null);
    const [email, setEmail] = useState(userData ? userData.user.email : "");
    const [mob, setMob] = useState(userData ? userData.user.mobile : "");
    const [isEdit] = useState(userData && Object.keys(userData).length ? true : false);
    const [unblock, setUnblock] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [errMsg, setErrorMsg] = useState(null);
    const [image, setImage] = useState(null);
    const [disabledInviteBtn, setDisabledinviteBtn] = useState(false);
    const [radioValue, setRadioValue] = useState(userData && userData.isSiteRestricted ? "Restricted" : null);
    const [selCountry, setSelectedCountry] = useState(userData && userData.country ? userData.country : null);
    const [permissions, setpermissions] = useState(new Set());
    const [accessTitles] = useState(JSON.parse(JSON.stringify(accessTitle)));
    const [stateList, setStateList] = useState(null);
    const [selectedStates, setSelectedStates] = useState(userData && userData.states ? userData.states : null);
    const [cities, setCitiesList] = useState(null);
    const [selectedCities, setSelectedCities] = useState(userData && userData.cities ? userData.cities : null);
    const [pincodes, setPincodes] = useState(null);
    const [selectedPincodes, setSelectedPincodes] = useState(userData && userData.zipcodes ? userData.zipcodes : null);
    const [desginerType, setDeginerType] = useState(false);
    const allVendors = props.allVendors.length ? props.allVendors.map((v) => ({ label: v.name, value: v.vendorID })) : [];
    const [selectedVendors, setSelectedVendors] = useState(props.selectedUser?.user?.catalogAccess && props.selectedUser?.user?.catalogAccess.length ? props.selectedUser?.user?.catalogAccess : []);
    
    let nqpermissions = JSON.parse(localStorage.getItem("permissions"));

    const isSuperAdmin = nqpermissions.includes(superAdmin)
    const isDesignerAdmin = nqpermissions.includes(designerAdmin)
    
    const [selectedTradePartner, setSelectedTradePartner] = useState(isDesignerAdmin ? localStorage.getItem("orgId"): null);
    const navigate = useHistory();

    const message = useRef();
    const defcountryCode = {
        india: "IN",
        mexico: "MX",
        canada: "CA",
        usa: "US",
    };
    let defCode = serviceData.location && serviceData.location.operatingCountry ? defcountryCode[serviceData.location.operatingCountry] : serviceData.customer && serviceData.customer.region ? serviceData.customer.region.toUpperCase() : "IN";



    useEffect(() => {
        if (userData && userData.image) {
            setImageUrl(process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(userData.image));
        }

        if (userData && userData.permissions && userData.permissions.length) {
            userData.permissions.forEach((p) => {
                let permsn = accessTitles.findIndex((a) => a.hasOwnProperty(p));
                if (permsn > -1) {
                    accessTitles[permsn][p] = true;
                    accessTitles[permsn].unblock = true;
                }
                permissions.add(p);
            });
            setpermissions(permissions);
        }
    }, []);

    const handleImageUpload = (value) => {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(value);
        fileReader.onload = (event) => {
            setImageUrl(event.target.result);
            setImage(value);
        };
    };

    const manageModuleAccess = (access, type) => {
        let permission = accessTitles.findIndex((a) => a.name === type);
        if (access === "block") {
            accessTitles[permission][type + ".READ"] = false;
            accessTitles[permission].unblock = false;
            accessTitles[permission][type + ".WRITE"] = false;

            permissions.delete(type + ".READ");
            permissions.delete(type + ".WRITE");
        }
        if (access === "read") {
            accessTitles[permission][type + ".READ"] = true;
            accessTitles[permission].unblock = true;
            permissions.add(type + ".READ");
        }
        if (access === "write") {
            permissions.add(type + ".READ");
            permissions.add(type + ".WRITE");
            accessTitles[permission][type + ".READ"] = true;
            accessTitles[permission].unblock = true;
            accessTitles[permission][type + ".WRITE"] = true;
        }

        if (unblock) setUnblock(false);
        else setUnblock(true);
    };
    const getCountryCodeFromMob = (mob) => {
        let mobileCountry = parsePhoneNumber(mob);
            if (mobileCountry && mobileCountry.country) {
                return getCountryCallingCode(mobileCountry.country);
            }
        return null;
    }

    const onInviteUser = (e) => {
        e.target.blur();
        let res = validateInput();
        if (typeof res === "string") {
            return setErrorMsg(res);
        } else {
            setDisabledinviteBtn(true);

            let formData = new FormData();

            if (image) formData.append("profileImg", image);

            // let isSiteRestricted = false;
            // if (radioValue) {
            //     if (radioValue === "All") isSiteRestricted = false;
            //     else isSiteRestricted = true;
            // }

            if (!isEdit) {
                // invite user payload
                formData.append("serviceId", serviceId);
                formData.append("role", "ihdesigner");
                formData.append("isSiteRestricted", false);

                let countryCode = getCountryCodeFromMob(mob);
                
                formData.append("countryCode", "+" + countryCode);
                const phone_no = mob.split("+" + countryCode)[1];
                formData.append("mobile", phone_no);
                formData.append("email", email);
                // let permisssionArray = [...permissions];
                let permisssionArray = ["UserManagement.READ", "UserManagement.WRITE"];
                formData.append("permissions", JSON.stringify(permisssionArray));
            }

            if (isEdit) {
                formData.append("name", name);
                if (userData && userData.user && userData.user.userId) formData.append("userId", userData.user.userId);

                tenantService
                    .updateUserDetails(formData)
                    .then((res) => {
                        if (res && res.message) {
                            let msg;
                            if (res.responseCode === 200) {
                                msg = "User updated successfully";
                                if (isDesigner()) {
                                    const updateUserInfoPayload = {
                                        name,
                                        email,
                                        mobile: mob,
                                        userType: desginerType ? "brandAmbassador" : "normalUser",
                                        catalogAccess: selectedVendors,
                                    };
                                    if (userData && userData.user) {
                                        updateUserInfoPayload.orgId = !userData.user.org ? selectedTradePartner : userData.user.org._id;
                                    }
                                    tenantService
                                        .updateDesignerInfo(updateUserInfoPayload)
                                        .then((res) => {
                                            props.onSuccess(false, msg);
                                        })
                                        .catch((err) => {
                                            setDisabledinviteBtn(false);
                                            setErrorMsg(err.response?.data?.message ?? "Designer Code update failed");
                                        });
                                } else {
                                    props.onSuccess(false, msg);
                                }
                            }
                        }
                    })
                    .catch((e) => {
                        setDisabledinviteBtn(false);
                        setErrorMsg(e.response?.data?.message || e.message || "Some error occured. Please try again later.");
                        console.error(e);
                    });
            } else {
                formData.append("firstName", name);
                if (selCountry) formData.append("country", selCountry);
                if (selectedStates && selectedStates.length) formData.append("states", JSON.stringify(selectedStates));
                if (selectedCities && selectedCities.length) formData.append("cities", JSON.stringify(selectedCities));
                if (selectedPincodes && selectedPincodes.length) formData.append("zipcodes", JSON.stringify(selectedPincodes));

                tenantService
                    .addUserByCustomer(formData)
                    .then((res) => {
                        if (res && res.message) {
                            let msg;
                            if (res.responseCode === 200) {
                                const updateUserInfoPayload = {
                                    name,
                                    email,
                                    mobile: formData.get("countryCode") + formData.get("mobile"),
                                    userType: desginerType ? "brandAmbassador" : "normalUser",
                                    catalogAccess: selectedVendors,
                                };
                                if (selectedTradePartner !== null) {
                                    updateUserInfoPayload.orgId = selectedTradePartner;
                                }
                                tenantService
                                    .updateDesignerInfo(updateUserInfoPayload)
                                    .then((res) => {
                                        msg = "User with mobile no " + mob + " added successfully";
                                        props.onSuccess(false, msg);
                                    })
                                    .catch((err) => {
                                        setDisabledinviteBtn(false);
                                        setErrorMsg(err.response?.data?.message ?? "Designer Code update failed");
                                    });
                            }
                            setErrorMsg(res.message);
                            props.onSuccess(false, msg);
                        }
                    })
                    .catch((e) => {
                        setDisabledinviteBtn(false);
                        setErrorMsg(e.response?.data?.message ?? "User Creation Failed");
                    });
            }
        }
    };

    const validateMobile = (mob) => {
        if (mob.length > 6 && mob.length < 16) return getCountryCodeFromMob(mob) ? true : false;
        else return false;
    };

    const validateInput = () => {
        if (!name) return "Please enter the name";
        if (!isEdit && selectedTradePartner === null) {
            return "Please select the Trade Partner Name";
        }
        if(userData && userData.user.role!=='ihcustomer'){
            if (isEdit && userData && userData.user && !userData.user.org && selectedTradePartner === null) {
                return "Please select the Trade Partner Name";
            }
        }
        if (!isEdit && (!email || !validateEmail(email))) return "Invalid email! Please enter a valid email";
        if (!mob || !validateMobile(mob)) return "Invalid mobile! Please enter a valid mobile number";
        if (!image && !imageUrl) return "Please upload the image";
        if (radioValue && radioValue === "Restricted" && !(selectedStates && selectedStates.length)) return "Please select the restricted area";
        if (isEdit && !(userData && userData.user && userData.user.cognitoId)) {
            console.error("CognitoId is not present in the user permissions");
            return "Server Error";
        }
        return true;
    };

    const onCountryChange = (e) => {
        setSelectedCountry(e.value);
        setStateList([]);
        setSelectedStates(null);
        getStateList(e.value);
    };

    useEffect(() => {
        if (userData && userData.country) {
            setDisabledinviteBtn(true);
            getStateList(userData.country);
        }
    }, []);

    const getStateList = async (country) => {
        if (country) {
            let [error, stateList] = await parseResponse(ConfigService.getStateList({ country: country, serviceId }));
            if (error) {
                message.current.show({ severity: "error", content: "Something wents wrong" });
                return;
            }
            let states = [];
            stateList.forEach((s) => {
                states.push({ name: convertCamelCase(s), value: s });
            });
            setStateList(states);
            if (userData && !(userData.states && userData.states.length)) setDisabledinviteBtn(false);
        }
    };

    const onStateSelection = (e) => {
        setSelectedStates(e.value);
        setCitiesList([]);
        setPincodes([]);
        setSelectedCities(null);
        setSelectedPincodes(null);
    };

    useEffect(() => {
        cityDebounceFunction(getCityList, 2000, selectedStates);
    }, [selectedStates && selectedStates.length]);

    const cityDebounceFunction = (func, delay, params) => {
        clearTimeout(citytimerId);
        citytimerId = setTimeout(() => {
            func(params);
        }, delay);
    };

    const zipcodeDebounceFunction = (func, delay, params) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func(params);
        }, delay);
    };

    const getCityList = async (states) => {
        if (states && states.length) {
            let [error, cityList] = await parseResponse(ConfigService.getCities({ states: states, serviceId }));
            if (error) {
                message.current.show({ severity: "error", content: "Something wents wrong" });
                return;
            }

            let cities = [];
            cityList.forEach((s) => {
                cities.push({ name: convertCamelCase(s), value: s });
            });

            setCitiesList(cities);
            if (userData && !(userData.cities && userData.cities.length)) setDisabledinviteBtn(false);
        }
    };

    useEffect(() => {
        zipcodeDebounceFunction(getPincodeList, 2000, selectedCities);
    }, [cities && selectedCities && selectedCities.length]);

    const getPincodeList = async (cities) => {
        if (cities && cities.length) {
            let [error, pincideList] = await parseResponse(ConfigService.getPincodes({ cities: cities, serviceId }));
            if (error) {
                message.current.show({ severity: "error", content: "Something wents wrong" });
                return;
            }

            let pincodes = [];
            pincideList.forEach((p) => {
                pincodes.push({ name: p, value: p });
            });
            setPincodes(pincodes);
            setDisabledinviteBtn(false);
        }
    };

    const onCitySelection = (e) => {
        setSelectedCities(e.value);
        setPincodes([]);
        setSelectedPincodes(null);
    };

    const onPincodeSelection = (e) => {
        setSelectedPincodes(e.value);
    };
    const isDesigner = () => {
        return props?.selectedUser?.user?.role === "ihdesigner" ? true : false;
    };

    // const RoleSelector = (role) => {
    //     useEffect(() => {
    //         if (role === "superAdmin") {
    //             setSelectedPincodes([]);
    //         }
    //     }, [role]);

    //     if (role === "Manager" || role === "Users") {
    //         return (
    //             <>
    //                 <label htmlFor="mob" className="block">
    //                     Select Plaza
    //                 </label>
    //                 <Dropdown
    //                     value={selectedPincodes}
    //                     onChange={(e) => {
    //                         setSelectedPincodes(e.value);
    //                     }}
    //                     options={plazaList}
    //                     optionLabel="name"
    //                     placeholder="Select Plaza"
    //                     maxSelectedLabels={3}
    //                     className="w-full"
    //                 />
    //             </>
    //         );
    //     }

    //     if (role === "Revenue Manager") {
    //         return (
    //             <>
    //                 <label htmlFor="mob" className="block">
    //                     Select Plaza
    //                 </label>
    //                 <MultiSelect
    //                     value={selectedPincodes}
    //                     onChange={(e) => {
    //                         setSelectedPincodes(e.value);
    //                     }}
    //                     options={plazaList}
    //                     optionLabel="name"
    //                     placeholder="Select Plaza"
    //                     maxSelectedLabels={3}
    //                     className="w-full"
    //                 />
    //             </>
    //         );
    //     }

    //     return null;
    // };

    const AddTradePartnerButton = ()=>{
        return  <Button label="Add Trade Partner" icon='pi pi-plus pi-sm'  className="mt-2 hover:bg-gray-900 sage-ivory" onClick={() => navigate.push("/add-trade-partner")}></Button>
    }

    return (
        <div className="grid">
            <div className="col-12  ">
                <label htmlFor="invite-image" style={{ cursor: "pointer" }}>
                    {!imageUrl ? (
                        <div style={{ textAlign: "center" }}>
                            <img height="40px" width="40px" alt="upload" src={"/images/upload.svg"} required />
                            <div>Upload Image</div>
                        </div>
                    ) : (
                        <div style={{ textAlign: "center" }}>
                            <img height="100px" alt="change" width="100px" src={imageUrl} />
                            <div>Change Image</div>
                        </div>
                    )}
                </label>
                <input style={{ display: "none" }} id="invite-image" type="file" accept="image/jpg, image/jpeg, image/png" onChange={(e) => handleImageUpload(e.target.files[0])} />
            </div>
            <div className="col-12">
                <label htmlFor="name" className="block mb-1">
                    Name
                </label>
                <InputText type="text" name="name" id="name" className="w-full" defaultValue={name} onChange={(e) => setName(e.target.value)} />
            </div>
            {
                userData && userData?.user?.role === 'ihcustomer' ? null : <div className="col-12">
                    <label htmlFor="name" className="block mb-1">
                        Trade Partner Name
                    </label>
                    {isEdit && props?.selectedUser?.user?.org?.orgLegalName ? <InputText type="text" className="w-full" defaultValue={props?.selectedUser?.user?.org?.orgLegalName} disabled /> : props?.tradePartners && props?.tradePartners.length > 0 ? (
                        <>
                            <Dropdown
                                disabled= {isDesignerAdmin}
                                value={selectedTradePartner}
                                onChange={(e) => setSelectedTradePartner(e.value)}
                                options={props?.tradePartners}
                                optionLabel="orgLegalName"
                                optionValue="_id"
                                placeholder="Search Trade Partners here"
                                filter
                                showClear
                                className="w-full custom-chip-multiselect"
                            />
                           {isSuperAdmin && <AddTradePartnerButton />} 
                        </>
                    ) : isSuperAdmin ? (
                        <AddTradePartnerButton />
                    ): null}
                </div>
            }
            <div className="col-6">
                <label htmlFor="email" className="block mb-1">
                    Email
                </label>
                <InputText type="email" name="email" id="email" className="w-full" disabled={isEdit} defaultValue={email} onChange={(e) => setEmail(e.target.value)} />
                {/* <InputText type="email" name="email" id="email" className="w-full" defaultValue={email} onChange={(e) => setEmail(e.target.value)} /> */}
            </div>

            <div className="col-6">
                <label htmlFor="mob" className="block mb-1">
                    Mobile
                </label>
                <PhoneInput
                    disabled={isEdit}
                    placeholder="Enter phone number"
                    className={`p-inputtext p-component p-filled w-full ${isEdit ? "phone-input--disabled" : ""}`}
                    value={mob}
                    onChange={setMob}
                    international
                    defaultCountry={defCode}
                    error={mob ? (isValidPhoneNumber(mob) ? undefined : "Invalid phone number") : "Phone number required"}
                />
                {/* <InputText type="text" name="mob" id="mob" className="w-full" defaultValue={mob} onChange={(e) => setMob(e.target.value)} /> */}
            </div>

            {isDesigner() && (
                <div className="col-12">
                    <label htmlFor="name" className="block mb-1">
                        Catalog Access
                    </label>
                    <MultiSelect value={selectedVendors} onChange={(e) => setSelectedVendors(e.value)} options={allVendors} optionLabel="label" filter placeholder="Select Vendors" maxSelectedLabels={3} className="w-full custom-chip-multiselect" display="chip" />
                    <p className="text-xs mt-1">If no vendor is selected, the designer has access to all the vendors.</p>
                </div>
            )}

            {!isEdit && (
                <div className="col-12 ">
                    <>
                        <Checkbox inputId="ingredient1" name="select" onChange={(e) => setDeginerType(!desginerType)} checked={desginerType === true} />
                        <label htmlFor="ingredient1" className="ml-1 mr-4">
                            Brand Ambassador
                        </label>
                    </>
                </div>
            )}

            <div className="col-12">
                <Messages ref={message} />
            </div>
            {errMsg && (
                <div className="col-12">
                    <div className="text-left errorstyle" style={{ color: "red" }}>
                        {errMsg}
                    </div>
                </div>
            )}

            <div className="col-12">
                <Button className="col-12" disabled={disabledInviteBtn} style={{ textAlign: "center", padding: "1rem" }} onClick={(e) => onInviteUser(e)}>
                    {isEdit ? "Update User" : "Invite user"}
                </Button>
            </div>
        </div>
    );
};

export default InviteUser;
